import * as types from './mutation-types';

export default {
    /**
     * 追加历史记录数据到当前列表中
     * @param {*} state 
     * @param {*} data {reload:代表重新加载，new：true代表新的数据，data：[{具体的数据}]}
     */
    [types.DEVELOP_HISTORY_ACTION_LIST](state, data) {
        if(data.reload){
            state.developHistoryActionDate=[];
            state.developHistoryActionList=[];
            return;
        }
        if(data.new){
            //插入到前面
            data.data.reverse().forEach(element => {
                state.developHistoryActionList.unshift(element);
                if(_.indexOf(state.developHistoryActionDate, element.opDate)==-1){
                    state.developHistoryActionDate.unshift(element.opDate);
                }
            });
        }else{
            //合并到后面
            data.data.forEach(element => {
                state.developHistoryActionList.push(element);
                if(_.indexOf(state.developHistoryActionDate, element.opDate)==-1){
                    state.developHistoryActionDate.push(element.opDate);
                }
            });
        }
    },
    [types.DEVELOP_CURRENT_THEME_KEY](state,data){
        state.developCurrentThemeKey = data;
    },
    [types.DEVELOP_MARKET_MODULE_LIST](state,data){
        state.developMarketModuleList = data;
    },
    [types.DEVELOP_CUSTOM_MODULE_LIST](state,data){
        state.developCustomModuleList = data;
    }
}